import React from "react";
import TimeAgo from "react-timeago";
import { cleanDate } from "../../../util/app";

function StaffRotaList({ items = [] }) {
    if (items.length < 1)
        return (
            <div className="text-center text-pink m-t-20">
                <i className="material-icons" style={{ fontSize: "2em" }}>
                    info
                </i>
                <br />
                <strong>No Rota!</strong>
            </div>
        );
    return (
        <div className="no-pad table-responsive">
            <table className="table table-bordered table-hover">
                <thead>
                    <tr>
                        <th className="text-center">SN</th>
                        <th>Period</th>
                        <th>Moment Ago</th>
                        <th>Date & Time</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td className="text-center">
                                <span>{index + 1}</span>
                            </td>
                            <td className="view-message">
                                <span>{item.period.name}</span>
                            </td>
                            <td>
                                <span className="badge badge-primary">
                                    <TimeAgo date={item.date}></TimeAgo>
                                </span>
                            </td>

                            <td className="view-message">{cleanDate(item.date, false, false)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default StaffRotaList;
